type WelcomeMessageConfig = {
  showWelcomeAsFirstMessage: boolean;
  welcomeMessage: string;
};

type TextInputVisibility = {
  allowTextInput: boolean;
  hasMessages: boolean;
  flowState: string;
};

export const isWelcomeMessageShown = ({
  showWelcomeAsFirstMessage,
  welcomeMessage,
}: WelcomeMessageConfig): boolean =>
  showWelcomeAsFirstMessage && !!welcomeMessage.trim();

// * An LLM flow can start without a bot message, because the LLM block waits for
// * the first question. The 'llm' flow state arrives after the user id, and a
// * session reset clears it, so a message never goes out without a user id.
export const shouldShowTextInput = ({
  allowTextInput,
  hasMessages,
  flowState,
}: TextInputVisibility): boolean =>
  allowTextInput && (hasMessages || flowState === 'llm');
